/* jh-home-shipbar.js
   Fixes the homepage free-shipping progress message so it shows a REAL
   converted amount in the customer's active currency (SAR, AED, etc.),
   instead of the raw GBP number with just the currency symbol swapped.
   Loaded from jh-homepage.liquid, only on the homepage. */
(function () {
  "use strict";

  var wrap = document.getElementById("jhHomeShipWrap");
  if (!wrap) { return; }

  var msgEl = document.getElementById("jhHomeShipMsg");
  var fillEl = document.getElementById("jhHomeShipFill");
  if (!msgEl || !fillEl) { return; }

  var THRESHOLD_GBP_PENCE = 4000; /* GBP40.00 */
  var isAr = (document.documentElement.lang === "ar");

  function formatMoney(pence, code, lang) {
    var amount = pence / 100;
    try {
      return new Intl.NumberFormat(lang, { style: "currency", currency: code }).format(amount);
    } catch (e) {
      return code + " " + amount.toFixed(2);
    }
  }

  function render(cart) {
    var cur = (window.Shopify && window.Shopify.currency) || {};
    var rate = parseFloat(cur.rate) || 1;
    var code = cur.active || "GBP";
    var lang = isAr ? "ar-u-nu-arab" : undefined;

    var thresholdActive = Math.round(THRESHOLD_GBP_PENCE * rate);
    var totalActive = cart.total_price;

    if (totalActive >= thresholdActive) {
      msgEl.innerHTML = isAr
        ? "\ud83c\udf89 \u0644\u0642\u062f \u062d\u0635\u0644\u062a \u0639\u0644\u0649 <strong>\u062a\u0648\u0635\u064a\u0644 \u0645\u062c\u0627\u0646\u064a!</strong>"
        : "\ud83c\udf89 You've unlocked <strong>free delivery!</strong>";
      fillEl.style.width = "100%";
    } else {
      var remaining = thresholdActive - totalActive;
      var pct = (totalActive / thresholdActive) * 100;
      var remainingText = formatMoney(remaining, code, lang);
      msgEl.innerHTML = isAr
        ? "\u0623\u0646\u062a \u0639\u0644\u0649 \u0628\u0639\u062f <strong>" + remainingText + "</strong> \u0645\u0646 \u0627\u0644\u062a\u0648\u0635\u064a\u0644 \u0627\u0644\u0645\u062c\u0627\u0646\u064a"
        : "You're <strong>" + remainingText + "</strong> away from free delivery";
      fillEl.style.width = pct + "%";
    }
  }

  fetch("/cart.js")
    .then(function (r) { return r.json(); })
    .then(render)
    .catch(function () { /* leave the server-rendered fallback text in place */ });
})();